import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const LINKS = [
  { id: "solutions", label: "Solutions" },
  { id: "industries", label: "Industries" },
  { id: "cases", label: "Case Studies" },
  { id: "ai-lab", label: "AI Demo", action: "chat" },
  { id: "pricing", label: "Revenue Simulator" },
  { id: "competitors", label: "Competitor Analysis" },
  { id: "resources", label: "Resources" },
  { id: "contact", label: "Contact" },
];

const LOGO_URL = "/munnexa-logo.png";

export default function Nav({ onOpenChat }) {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handle = (l) => {
    if (l.action === "chat" && onOpenChat) {
      onOpenChat();
      return;
    }
    if (!isHome) {
      window.location.href = `/#${l.id}`;
      return;
    }
    const el = document.getElementById(l.id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-4 left-1/2 -translate-x-1/2 z-50 transition-all duration-500 w-[min(1240px,96%)]`}
      data-testid="main-nav"
    >
      <div className={`glass holo-border rounded-2xl px-3 sm:px-5 py-2.5 flex items-center justify-between gap-3 ${scrolled ? "shadow-2xl" : ""}`}>
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo-button">
          <div className="relative w-12 h-12 sm:w-14 sm:h-14 rounded-xl overflow-hidden ring-1 ring-white/15 group-hover:ring-cyan-400/60 transition shadow-lg">
            <img src={LOGO_URL} alt="MUNNEXA" className="w-full h-full object-cover" />
          </div>
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="font-[Outfit] font-bold text-xl tracking-wide text-gradient">MUNNEXA</span>
            <span className="font-mono text-[10px] tracking-[0.3em] text-cyan-300/80 mt-0.5">THE NEXT ERA</span>
          </div>
        </Link>

        <nav className="hidden xl:flex items-center gap-1">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => handle(l)}
              data-testid={`nav-link-${l.id}`}
              className="relative px-3 py-1.5 rounded-full text-[13px] text-white/75 hover:text-white transition group whitespace-nowrap"
            >
              <span className="relative z-10">{l.label}</span>
              <span className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition" style={{ background: "radial-gradient(circle at center, rgba(0,240,255,0.25), transparent 70%)" }} />
            </button>
          ))}
        </nav>

        <button
          onClick={() => isHome ? document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" }) : (window.location.href = "/#contact")}
          data-testid="nav-cta-button"
          className="btn-gradient rounded-full px-4 py-2 text-sm"
        >
          Book Demo
        </button>
      </div>
    </header>
  );
}
